import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[appAutoFocus]',
    standalone: false
})
export class FocusDirective implements OnInit, OnChanges, OnDestroy {
    @Input('appAutoFocus') shouldBeFocused: boolean;
    timer: any;
    readonly timerDelay = 10;

    constructor(private elementRef: ElementRef) {}

    ngOnInit() {
        if (this.shouldBeFocused) {
            // this.renderer.invokeElementMethod(this.hostElement.nativeElement, 'focus');
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.shouldBeFocused) {
            if (this.shouldBeFocused) {
                this.startFocus();
            } else {
                this.stopFocus();
            }
        }
    }

    startFocus() {
        if (this.timer) {
            return;
        }

        this.timer = setTimeout(
            () => {
                this.timer = null;
                const item = this.elementRef.nativeElement;
                if (item.nodeName === 'CUSTOM-EDITOR') {
                    item.children[0].children[0].children[0].focus();
                } else {
                    this.elementRef.nativeElement.focus();
                }
            },

            this.timerDelay
        );
    }

    stopFocus() {
        clearTimeout(this.timer);
        this.timer = null;
    }

    ngOnDestroy() {
        this.stopFocus();
    }
}
